import { Box, Typography } from '@mui/material';

export default function HeaderBreadcrumb({ variant, year, company, group, facility, category, dataCapturingCategory, generalInformationOption, conversionFactor }) {
    return (
        <Box sx={{ background: '#535988', borderRadius: 2, p: 2 }}>
            <Typography variant='h5' sx={{ fontWeight: 'bold', color: 'whitesmoke' }}>
                {variant === 'data-capturing' &&
                    'Data Capturing'}
                {variant === 'conversion-factors' &&
                    'Conversion Factors'}
                {variant === 'general-information' &&
                    'General Information'}
            </Typography>
            <Typography variant='h7' sx={{ color: 'whitesmoke' }}>
                {year ? `Year: ${year}` : "Select Year"}
                {company && ` - Company: ${company.name}`}
                {group && ` - Group: ${group.name}`}
                {facility && ` - Facility: ${facility.name}`}
                {category && variant !== 'conversion-factors' && ` - ${category.name}`}
                {dataCapturingCategory && `: ${dataCapturingCategory}`}
                {generalInformationOption && ` - Information: ${generalInformationOption}`}
                {conversionFactor && ` - ${conversionFactor}`}
                {category && conversionFactor === 'Emission Factors' && ` - ${category.name}`}
            </Typography>
        </Box>
    )
}